import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import {
  BottomText,
  ImageContainer,
  Item,
  Keys,
  Link,
  SeminarLeft,
  SeminarRight,
  SeminarTitle,
  Values,
} from './Seminar.style';

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面 > 一覧 > 各内容
 */
const Seminar = ({ copy, locale, months, seminar }) => {
  const dateObj = new Date(seminar.date);
  const day = dateObj.getDate();
  const month = dateObj.getMonth();
  const monthName = months[month];
  const year = dateObj.getFullYear();

  return (
    <Item>
      <Link
        to={{
          pathname: `/${locale}/education/${seminar.slug}`,
          state: {
            prevPath: `/${locale}/seminar-schedule`,
          },
        }}
        href={`/${locale}/education/${seminar.slug}`}
      >
        <SeminarLeft>
          <SeminarTitle>{seminar.name || <Placeholder w="100%" pb="50%" />}</SeminarTitle>
          {/* <ImageContainer>
            {seminar.photoGallery ? (
              <Image src={seminar.photoGallery[0]} options={{ w: '100%', size: 300 }} />
            ) : (
              <Placeholder w="100%" h="100%" />
            )}
          </ImageContainer> */}
        </SeminarLeft>

        <SeminarRight>
          <div>
            <p>{seminar.category ? `${seminar.category} / ${seminar.location}` : <Placeholder w="100%" h="20px" />}</p>
            <p>{seminar.description || <Placeholder w="100%" h="80px" />}</p>
            <p>{seminar.address || <Placeholder w="100%" h="40px" />}</p>
          </div>

          <BottomText>
            <Keys>
              <p>{copy.date ? `${copy.date}:` : <Placeholder w="95%" h="20px" />}</p>
              <p>{copy.audience ? `${copy.audience}:` : <Placeholder w="95%" h="20px" />}</p>
            </Keys>
            <Values>
              <p>{seminar.date ? `${day} ${monthName} ${year}` : <Placeholder w="100%" h="20px" />}</p>
              {seminar.targetAudience ? (
                <p>
                  {seminar.targetAudience.map(
                    (audience, index) =>
                      index === 0 ? <span key={audience}>{audience}</span> : <span key={audience}> / {audience}</span>
                  )}
                </p>
              ) : (
                <Placeholder w="100%" h="20px" />
              )}
            </Values>
          </BottomText>
        </SeminarRight>
      </Link>
    </Item>
  );
};

Seminar.propTypes = {
  copy: PropTypes.shape().isRequired,
  locale: PropTypes.string.isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  seminar: PropTypes.shape().isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(Seminar);



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarsList/Seminar.js